module.exports = __webpack_public_path__ + "static/media/data-visualization-3.8c076821.jpg";